function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { SvgIcon } from "./SvgIcon";
var smallPath = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "10"
}), /*#__PURE__*/React.createElement("rect", {
  className: "checkicon-fill",
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  className: "checkicon-check",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7"
})));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
export var CheckboxIcon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _objectSpread({
    paths: paths
  }, props));
});
CheckboxIcon.displayName = "Checkbox";